<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<!-- Helper-component bij planbord - voor de leesbaarheid. Meeste logica staat in de planbordcode -->
<div class="planitem" #hetblokje
     [title]="(toonkritiek && planitem.heeftKritiek ? (planitem.kritiekTekst + '\n\n') : '') + planitem._tags['title']"
     [class.visual]="visual"
     [class.todo]="planitem.project.factureerbaar && planitem.implementationDegree !== 0"
     [class.kritiek]="toonkritiek && planitem.heeftKritiek"
     [class.atw]="planitem.kritiekPerCat['atw']?.length"
     [class.noticeme]="noticeme"
     (animationend)="noticeme = false"
     [class.virtueel]="virtueel"
     [attr.data-factureerbaar]="planitem.project.factureerbaar ? 'ja': 'nee'"
     [style.left]="visual ? null : (planitem._tags.startRelative * 100) + '%'"
     [style.width]="visual ? null : ((planitem._tags.endRelative - planitem._tags.startRelative) * 100) + '%'"
     (click)="onEdit()" (touchstart)="onEdit()"
>
    <div class="blockinfo">
        <div class="tijden ">{{ planitem.starttime }} - {{ planitem.endtime }}</div>
        <div class="function"
             *ngIf="weergave === 'invulling' || weergave === 'invulling_planning'">{{ planitem._tags['functiontitle'] }}
        </div>
        <div class="project "
             *ngIf="weergave === 'invulling' || weergave === 'invulling_planning'">{{ planitem.project?.label }}
        </div>
        <div class="namen" *ngIf="weergave === 'project'">
            <div *ngFor="let pers of planitem.personeel" [class.font-italic]="isAndereWM(pers)">{{ pers.naam }}</div>
        </div>
        <div class="impldegree "
             *ngIf="(planitem.project.factureerbaar)  && (weergave === 'project' || weergave === 'invulling_planning')">
            <span *ngIf="!! planitem.leverancier_id" class="fas" [class.fa-truck]="! (planitem.gelockt)"
                  [class.fa-lock]="(planitem.gelockt)"></span>
            @if (planitem.project.externe_werkmaatschappij) {
                <span class="fas fa-building" title="Uitlenen aan een andere werkmaatschappij"></span>
            } @else if (planitem.externe_werkmaatschappij) {
                <span class="fas fa-building" title="Inlenen van een andere werkmaatschappij"></span>
            }
            @if (planitem.serieskey?.length) {
                <span class="fa fa-ellipsis-h" title="Deze dienst maakt deel uit van een serie"></span>
            } {{ planitem.implemented }}
            / {{ planitem.capacity }}
        </div>
        <div class="planningbuttons" *ngIf="weergave === 'invulling_planning'">
            <div class="planningbuttons_addremove" (click)="onAddRemove()"><span *ngIf="virtueel"
                                                                                 class="fas fa-plus-circle"></span><span
                    *ngIf="! virtueel" class="fas fa-minus-circle"></span></div>
        </div>
    </div>
</div>
